export default "/assets/images/la-strong-bg.webp?6773fe61d4000fb8ea011d8f48fae9c1";